import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { GlassCard } from './GlassCard';

/**
 * ServiceCard Component - DARK EDITION
 * Optimized for black backgrounds with high-contrast medical typography.
 */
const ServiceCard = ({
  lang = 'en',
  title,
  description,
  features = [],
  image,
  delay = 0,
}) => {
  const isAr = lang === 'ar';

  return (
    <GlassCard
      delay={delay}
      className='group h-full flex flex-col overflow-hidden border-white/5 bg-white/[0.02] hover:border-medical-blue-500/30 transition-all duration-500'
    >
      {/* Image Header with Deep Dark Gradient Overlay */}
      <div className='relative h-64 w-full overflow-hidden'>
        <img
          src={image}
          alt={title}
          width='400'
          height='300'
          loading='lazy'
          className='w-full h-full object-cover grayscale-[10%] contrast-[1.1] transition-transform duration-700 group-hover:scale-110'
        />
        {/* Darker gradient to blend with black background */}
        <div className='absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/20 to-transparent' />

        {/* Title Overlay */}
        <div className={`absolute bottom-4 ${isAr ? 'right-6' : 'left-6'}`}>
          <h3 className='text-2xl font-black text-white tracking-tight'>
            {title}
          </h3>
        </div>
      </div>

      {/* Content Body */}
      <div
        className={`p-8 flex flex-col flex-grow ${isAr ? 'text-right' : 'text-left'}`}
      >
        <p className='text-gray-400 mb-6 font-medium leading-relaxed'>
          {description}
        </p>

        {/* Feature Checklist - Critical for Healthcare Trust */}
        <div className='space-y-3 mb-8 flex-grow'>
          {features.map((feature, index) => (
            <div
              key={index}
              className={`flex items-start gap-3 ${isAr ? 'flex-row-reverse' : ''}`}
            >
              <CheckCircle2
                size={18}
                className='text-trust-teal mt-0.5 shrink-0 opacity-90'
                aria-hidden='true'
              />
              <span className='text-sm font-bold text-gray-300'>{feature}</span>
            </div>
          ))}
        </div>

        {/* Action Link */}
        <button
          onClick={() => (window.location.href = '#contact')}
          className={`flex items-center gap-2 font-black text-sm uppercase tracking-widest text-medical-blue-400 group-hover:text-white transition-all ${isAr ? 'flex-row-reverse' : ''}`}
        >
          {isAr ? 'اطلب الخدمة الآن' : 'Request Service'}
          <ArrowRight
            size={18}
            className={`transition-transform duration-300 ${isAr ? 'rotate-180 group-hover:-translate-x-2' : 'group-hover:translate-x-2'}`}
          />
        </button>
      </div>
    </GlassCard>
  );
};

export default ServiceCard;
